module.exports = __webpack_public_path__ + "img/ico_save_revert.4100aeae.svg";